<template>
  <div class="container">
    <div class="login">
      <h1>Login</h1>
      <form @submit.prevent="login">
        <div class="row">
          <p class="err" v-if="error">{{ error }}</p>
        </div>

        <div class="row">
          <div class="eight columns">
            <label>
              User Name
              <input v-model="username" type="text" />
            </label>
            <label>
              Password
              <input v-model="password" type="password" />
            </label>
          </div>
          <div class="four columns">
            <button type="submit">login</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: "",
      error: false,
    };
  },
  watch: {
    username: function (val) {
      this.username = val.toString().replace(/(\d{4})(?=(\d))/g, "$1 ");
    },
  },
  methods: {
    login: function () {
      var self = this;
      if (this.username && this.password) {
        var name = this.username.replace(/\s+/g, "");
        var param = { username: name, password: this.password };
        console.log(param);

        this.$axios
          .post(this.$store.state.APIbase + "/login", param)
          .then((res) => {
            this.$store.dispatch("setUserName", this.username);
            this.$store.dispatch("setRole", res.data.role);

            if (self.$store.state.role == 0) {
              self.$router.push({ name: "Admin" });
            } else {
              self.$router.push({ name: "Home" });
            }
          })
          .catch((err) => {
            console.log(err);
            this.error = "ユーザ名かパスワードを間違えています。";
          });
      } else {
        this.error = "ユーザ名とパスワードを入力してください。";
      }
    },
  },
};
</script>

<style scoped>
.login {
  background: #bae8e8;
  margin-top: 5rem;
  margin-left: 10%;
  width: 80%;
  padding: 1rem;
  border-radius: 10px;
  font-family: "Baloo 2", cursive;
}
.login h1 {
  font-size: 3rem;
  text-align: center;
  color: #fff;
}
.err {
  background: #ffb1b1;
  font-weight: bold;
  color: #b80000;
  font-size: 1rem;
  padding: 5px;
  border-radius: 5px;
}
form {
  background: #fff;
  border-radius: 10px;
  padding: 20px;
}
form label {
  width: 100%;
  color: #272343;
}
input {
  width: 100%;
  border-radius: 0;
  border: none;
  border-bottom: solid 2px #272343;
  transition: all 0.3s;
}
input:focus {
  border: none;
  background: #e3f6f5;
  border-radius: 10px;
}
button {
  width: 100%;
  height: 180px;
  transition: all 0.3s;
  text-transform: none;
  font-size: 2rem;
}
button:hover {
  background: #e3f6f5;
  border: none;
}
@media (max-width: 699px) {
  button {
    height: auto;
  }
}
</style>
